import { useState, useEffect } from 'react';
import moment from 'moment';

/**
 * 获取当前时间在指定时间粒度下的开始时间点、结束时间点
 * @param dateType 时间粒度
 */
const getStartAndEndOfCurrentTime = (
  dateType: ScheduledateTypes = 'quarter',
): {
  start: string;
  end: string;
} => {
  const currentM = moment();
  return {
    start: currentM.startOf(dateType).format('YYYY-MM-DD'),
    end: currentM.endOf(dateType).format('YYYY-MM-DD'),
  };
};

/**
 * 判定指定时间是否在指定的时间范围内
 * @param params 参数对象
 * @param params.date 指定时间
 * @param params.start 开始时间
 * @param params.end 结束时间
 * @return 指定时间是否在指定的时间范围内
 */
const getIsInTimeRange = (params?: { date?: string; start?: string; end?: string }): boolean => {
  const { date, start, end } = params || {};
  if (!date || !start || !end) return false;
  const dateM = moment(date);
  const startM = moment(start);
  const endM = moment(end);
  if (!dateM.isValid() || !startM.isValid() || !endM.isValid()) return false;
  return dateM.isBetween(startM, endM, null, '[]');
};

export default function useInitialData(props?: {
  isLoading?: boolean;
  dateType?: ScheduledateTypes;
  data?: CommonCalendarDataTypes;
}) {
  const { isLoading = true, dateType = 'quarter', data = [] } = props || {};

  // 当前时间（结合当前时间、日历数据）
  const [currentTime, setCurrentTime] = useState('');
  // 日历数据（过滤无效数据，比如date为空的）
  const [dataList, setDataList] = useState<CommonCalendarDataTypes>([]);

  useEffect(() => {
    if (isLoading || !Array.isArray(data) || !data.length) {
      setCurrentTime('');
      setDataList([]);
      return;
    }

    const { start, end } = getStartAndEndOfCurrentTime(dateType);
    // 日历数据（过滤无效数据，比如date为空的）
    const dataListTmp: CommonCalendarDataTypes = [];
    // 当前时间（结合当前时间、日历数据）
    let currentTimeTmp = '';

    for (const dataItem of data) {
      const { date, list } = dataItem || {};
      if (!date) continue;
      const listTmp = list?.filter((item) => !!item) || [];
      // currentTimeTmp已匹配上正确的当前时间后，不再更新
      if (!currentTimeTmp) {
        if (getIsInTimeRange({ date, start, end })) {
          currentTimeTmp = date;
        }
      }
      dataListTmp.push({
        date,
        list: listTmp,
      });
    }

    setCurrentTime(currentTimeTmp);
    setDataList(dataListTmp);
  }, [isLoading, dateType, data]);

  return { currentTime, dataList };
}
